module.exports = __webpack_public_path__ + "img/audio.49910e9b.gif";